import Header from "../components/Header";


function About(){


return (

<div className="
min-h-screen
bg-slate-950
text-white
pt-32
">


<Header/>


<section className="
max-w-4xl
mx-auto
px-8
text-center
">


<h1 className="
text-5xl
font-bold
text-cyan-400
mb-10
">

درباره MEGA GAMES

</h1>



<p className="
text-gray-300
leading-10
text-lg
">


شرکت MEGA GAMES با تمرکز بر طراحی و تولید
تجهیزات سرگرمی هوشمند، فعالیت خود را در زمینه
بازی‌های تعاملی آغاز کرده است.

با بهره‌گیری از تجربه چندین ساله در حوزه
الکترونیک، نرم‌افزار و طراحی سیستم‌های هوشمند،
هدف ما ایجاد نسل جدیدی از سرگرمی‌های
تعاملی برای مراکز تفریحی، کافه‌ها و مجموعه‌های
سرگرمی است.


</p>


</section>


</div>

)


}


export default About;
